<template>
  <div class="home">
    <img class="banner" src="@/assets/img/bigbanner.png" alt="" srcset="">
    <div class="intr_box">
      <i></i>
      <div @click="show=true">
        <!-- <span>详情＞</span> -->
        <div>
          为服务全省大中小学生完成社会实践、展示成长收获，湖南日报新湖南客户端即日起正式开设“寒假社会实践”作品展示专区，并为优秀作品提供权威社会实践证书。

          本次活动以 “我的寒假成长日记” 为主题，面向全省小学、初中、高中、大学学生征集作品，截止日期为2月28日。作品须为原创，积极向上，形式可为：视频（3分钟内）、照片（3-5张配说明）、文字（日记或短文）。
          各学段都设置有推荐主题：
          （1）小学包括且不限于“我的家务日记”“身边的温暖”“寻味家乡年”“红色故事我来讲”；
          （2）中学包括且不限于“非遗文化守护者”“公益行动践行者”“长征精神践行者”；
          （3）大学包括且不限于“专业实践赋能基层”“志愿服务创新实践”“高校学子家乡行”等；
          同时面向所有学段征集“美好家乡推荐官”作品，助力同学们有针对性地开展实践。

          同学们可通过新湖南客户端专题页面提交作品及信息，审核通过后，作品将在平台按学段展示，并可接受点赞与分享。点赞量达到500以上，即可在平台申请下载加盖“湖南日报总编室”电子印章的社会实践证书，作为权威实践证明。证书获取进度可实时查询。
          我们期待同学们用镜头与笔墨记录实践，展现青春风采；也恳请家长与老师们予以支持，共同助力孩子们在实践中收获，在锻炼中成才。
          快来新湖南客户端写下你的“寒假成长日记”，留下这个冬天最温暖的实践印记！
        </div>
      </div>
    </div>
    <div class="parent_ul">
      <div v-for="item in work_ul" :key="item.id" @click="tolist(item.id)">
        <img :src="require(`@/assets/img/btn${work_ul.length - work_ul.indexOf(item)}.png`)" alt="" srcset="">
      </div>
    </div>
    <div @click="tobook" class="center_banner">
      <img src="@/assets/img/centerbanner.png" alt="" srcset="">
    </div>
    <div class="work_body">
      <div class="work_box">
        <div class="work_title">
          优秀作品展示
        </div>
      <ul class="work_ul">
        <li @click="reset(item)" v-for="(item,index) in work_ul" :key="index" :class="[{'work_li_sel':item.id==post_data.category_id}]">
          {{item.name}}
        </li>
      </ul>
      <div class="work_list_box">
        <div @click="to_work(item)" v-for="(item,index) in list" class="work_content_box">
          <div class="work_post">
            <p>{{item.title}}</p>
            <div >
              <h1>{{formatTimestampToDate(item.publish_time)}}</h1>
              <p @click.stop="upfn(item)">{{item.support_number}}
                 <img :src="getLikeIcon(item.tid)" alt=""> 
                </p>
            </div>
          </div>
          <img v-if="item.picture_url" :src="item.picture_url" alt="" srcset="">
          <img v-else src="@/assets/img/img.png" alt="" srcset="">
        </div>
      </div>
      <!-- <Waterfall :hasAroundGutter="false" :gutter="0" :space="0" :breakpoints="{
        1200: {
          rowPerView: 2,
        },
        800: {
          rowPerView: 2,
        },
        500: {
          rowPerView: 2,
        },
      }" imgSelector="picture" :list="list">
        <template #default="{ item, url, index }">
          <div class="work_content">
                     <div v-if="item.type == 3" class="work_text">
                      {{ item.describe }}
                     </div>
                <div v-else @click="to_work(item)" class="work_img">
                  <img :src="url" alt="" srcset="">
                </div>
                <p>{{item.title}}</p>
                <div class="user_box">
                  <div class="user_img">
                    <img :src="item.avatar" alt="" srcset="">
                  </div>
                <div @click="upfn(item)" class="up_box">
                  <span>{{item.upvote}}</span>
                  <img src="@/assets/img/up.png" alt="" srcset="">
                </div>
                </div>
              </div>
        </template>
      </Waterfall> -->
      <van-loading v-if="!isEnd" size="24px">加载中...</van-loading>
      <p class="no_more" v-else>暂无更多内容</p>
    </div>
    </div>
    <p class="technology_text">此作品部分内容由AI技术辅助生成</p>
  </div>
  <!-- 弹窗 -->
   <van-popup :close-on-click-overlay="false" overlay-class="rule_dialog_overlay" v-model:show="show" >
    <div class="rule_dialog">
      <div class="rule_scroll">
       为服务全省大中小学生完成社会实践、展示成长收获，湖南日报新湖南客户端即日起正式开设“寒假社会实践”作品展示专区，并为优秀作品提供权威社会实践证书。<br><br>

      本次活动以 “我的寒假成长日记” 为主题，面向全省小学、初中、高中、大学学生征集作品，截止日期为2月28日。作品须为原创，积极向上，形式可为：视频（3分钟内）、照片（3-5张配说明）、文字（日记或短文）。<br>
      各学段都设置有推荐主题：<br>
      （1）小学包括且不限于“我的家务日记”“身边的温暖”“寻味家乡年”“红色故事我来讲”；<br>
      （2）中学包括且不限于“非遗文化守护者”“公益行动践行者”“长征精神践行者”；<br>
      （3）大学包括且不限于“专业实践赋能基层”“志愿服务创新实践”“高校学子家乡行”等；<br>
      同时面向所有学段征集“美好家乡推荐官”作品，助力同学们有针对性地开展实践。<br><br>

      同学们可通过新湖南客户端专题页面提交作品及信息，审核通过后，作品将在平台按学段展示，并可接受点赞与分享。点赞量达到500以上，即可在平台申请下载加盖“湖南日报总编室”电子印章的社会实践证书，作为权威实践证明。证书获取进度可实时查询。<br>
      我们期待同学们用镜头与笔墨记录实践，展现青春风采；也恳请家长与老师们予以支持，共同助力孩子们在实践中收获，在锻炼中成才。<br>
      快来新湖南客户端写下你的“寒假成长日记”，留下这个冬天最温暖的实践印记！
      </div>
      <i @click="show = false"></i>
    </div>
   </van-popup>
</template>

<script  setup>
  import { showToast } from 'vant';
  import { ref ,onMounted,onUnmounted,defineEmits} from 'vue'
  import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
  import 'vue-waterfall-plugin-next/dist/style.css'
  import { useRouter ,useRoute} from 'vue-router'
  import api from '@/api'
  import { useStore } from 'vuex'
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const show = ref(false);
  const list = ref([])
  const loading = ref(false)
  const isEnd = ref(false)
  const emit = defineEmits(['showphone'])
  const work_ul = ref([
    {
      id:669,
      name:'大学生'
    },
    {
      id:664,
      name:'高中生'
    },
    {
      id:659,
      name:'初中生'
    },
    {
      id:644,
      name:'小学生'
    }
  ])
  function to_work(item){
    urlopen(item.url)
  }
  onMounted(()=>{
    getlist()
  })
  // 获取已点赞的ID列表
  const getLikedIds = () => {
    const likedIdsStr = localStorage.getItem('likedIds');
    return likedIdsStr ? JSON.parse(likedIdsStr) : [];
  };

  // 保存点赞ID到本地存储
  const saveLikedId = (id) => {
    const likedIds = getLikedIds();
    if (!likedIds.includes(id)) {
      likedIds.push(id);
      localStorage.setItem('likedIds', JSON.stringify(likedIds));
    }
  };

  // 检查是否已经点赞过
  const isAlreadyLiked = (id) => {
    const likedIds = getLikedIds();
    return likedIds.includes(id);
  };

  // 获取点赞图标
  const getLikeIcon = (id) => {
    return isAlreadyLiked(id) ? require('@/assets/img/uped.png') : require('@/assets/img/white_up.png');
  };

  const upfn = (item) => {
    if(store.state.token){
      // 检查是否已经点赞过
      if (isAlreadyLiked(item.tid)) {
        showToast('您已经点过赞了');
        return;
      }

      console.log(item)
      let post_data  = {
        id:item.tid,
        type:0,
        appid:9
      }
      api.like(post_data).then(res=>{
        if(res){
          showToast('点赞成功')
          // 点赞成功后保存ID到本地存储
          saveLikedId(item.tid);
          // 更新点赞数
          item.support_number = Number(item.support_number) + 1;
        }
      })
    }else{
      showToast({
        message:'请先登录',
        duration:1000
      })
      setTimeout(() => {
        // 调用父组件的 showphone 方法
        emit('showphone');
        // if(isXhn()){
        //   vmobile.getUserInfo();
        // }else{
        //   window.location.href = `https://wyy.voc.com.cn/voc/tougaoUsercheck.php?org_id=9&call_back=${window.escape(location.href)}`
        // }
      }, 1000);
    }
  }
  const post_data = ref({
    category_id:669,
    page:0,
    page_size:10,
    id:65
  })
  function reset(item){
    post_data.value.category_id = item.id
    post_data.value.page = 1
    list.value = []
    isEnd.value = false
    loading.value = false
    getlist()
  }
  function tolist(ids){
    router.push({path:'/list',query:{id:ids}})
  }
  function isXhn(){
      var UA = window.navigator.userAgent;
      var isAndroid = UA.indexOf('Android') > 0;
      var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
      var isXinhunan = false;
       var isHarmony = UA.indexOf('OpenHarmony') > 0;
      
      if (isAndroid || isIOS||isHarmony) {
        //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
        if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
        {
          isXinhunan = true;
        }	
      }
      return isXinhunan;
    }
    const tobook = () =>{
      if(store.state.token){
        router.push({path:'/book'})
      }else{
        showToast({
          message:'请先登录',
          duration:1000
        })
        setTimeout(() => {
          emit('showphone');
          // if(isXhn()){
          //   vmobile.getUserInfo();
          // }else{
          //   window.location.href = `https://wyy.voc.com.cn/voc/tougaoUsercheck.php?org_id=9&call_back=${window.escape(location.href)}`
          // }
        }, 1000);
      }
    }
  const urlopen = (url) =>{
    if(isXhn()){
      vmobile.openUrl('',url)
    }else{
      window.location.href = url
    }
  }
  // 滚动到底部触发加载更多
  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const clientHeight = document.documentElement.clientHeight
    const scrollHeight = document.documentElement.scrollHeight
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      console.log('触底了',loading.value,isEnd.value)
      if(loading.value || isEnd.value){
        return
      }
      // 触底，请求下一页
      post_data.value.page += 1
      getlist()
    }
  }
  function getlist(){
    if(loading.value){
      return
    }
     loading.value = true
    api.getlists(post_data.value).then(res => {
        if(!res){
          return
        }
        loading.value = false
        if(res.data.data.data.length < post_data.value.page_size){
          console.log('没有更多了')
          isEnd.value = true
        }
        list.value = [...list.value, ...res.data.data.data]
      })
  }
  // 绑定滚动事件
  window.addEventListener('scroll', handleScroll)

  // 组件卸载时移除事件
  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })
  
  // 时间戳转换为 yyyy-mm-dd 格式
  const formatTimestampToDate = (timestamp) => {
    // 确保时间戳是数字类型
    const time = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    
    // 如果时间戳长度小于10位，可能是秒级时间戳，需要乘以1000
    const ts = time.toString().length === 10 ? time * 1000 : time;
    
    const date = new Date(ts);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }
</script>

<style lang="scss">
.work_list_box{
  width: 100%;
  padding: 0 35px 35px;
}
.work_content_box{
  width: 100%;
  border-bottom: 2px solid rgba(255,255,255,0.13);
  display: flex;
  justify-content: space-between;
  height: 210px;
  padding: 30px 0;
  .work_post{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
     margin-right: 16px;
    &>p{
      font-size: 28px;
      color: #fff;
      text-align: justify;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    &>div{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      h1{
        color: rgba(255, 255, 255, 0.6);
        font-size: 22px;
      }
      p{
        font-size: 22px;
        color: rgb(255, 255, 255);
        img{
          width: 41px;
          margin-left: 5px;
        }
      }
    }
  }
  &>img{
    width: 224px;
    height: 100%;
    border-radius: 20px;
    object-fit: cover;
  }
}
  .no_more{
    font-size: 24px;
    color: rgba(255,255,255,0.7);
    line-height: 36px;
    margin-bottom: 27px;
    font-weight: normal;
    text-align: center;
  }
  .rule_dialog{
    width: 690px;
    height: 654px;
    background: url(~@/assets/img/dialog.png)no-repeat;
    background-size: 100% 100%;
    padding: 40px;
    box-sizing: border-box;
    position: relative;
    i{
      position: absolute;
      width: 84px;
      height: 84px;
      background: url(~@/assets/img/close.png)no-repeat;
      background-size: 100% 100%;
      bottom: -140px;
      left: 50%;
      transform: translateX(-50%);
    }
    .rule_scroll{
      width: 100%;
      height: 100%;
      overflow-y: auto;
      font-size: 24px;
      line-height: 38px;
      color: #fff;
    }
  }
  .waterfall-list{
    background: transparent!important;
    margin-top: 30px;
  }
  .van-popup--center{
    background: rgba(0, 0, 0, 0.8)!important;
    border-radius: 50px;
    overflow: inherit!important;
  }
  .work_content{
    width: 321px;
    background-color: #730BFE;
    border-radius:22px;
    border: 2px solid #040000;
    margin: 0 auto 23px;
    .work_text{
      width: 100%;
      padding: 12px 26px 22px;
      background: linear-gradient( 180deg, #FFFDFD 0%, #FCDEF5 100%);
      border-radius: 22px;
      border: 2px solid #040000;
      text-decoration: underline;
      text-underline-offset: 12px;
      font-size: 28px;
      color: #040000;
      line-height: 61px;
    }
    &>p{
      color: #FFFFFF;
      font-size: 26px;
      padding: 18px 18px 0 23px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .work_img{
      width: 100%;
      border-radius: 22px;
      border: 2px solid #040000;
      overflow: hidden;
      img{
        width: 100%;
        height:inherit;
        display: block;
        object-fit: cover;
      }
    }
    .user_box{
      width: 100%;
      height: 67px;
      padding: 0 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .user_img{
        width: 45px;
        height: 45px;
        border-radius: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .up_box{
        display: flex;
        justify-content: center;
        align-items: center;
        span{
          color: #FCDEF5;
          font-size: 24px;
        }
        img{
          width: 41px;
          height: 35px;
          margin-left: 10px;
        }
      }
    }
  }
  .work_ul{
    width: 650px;
    height: 70px;
    display: flex;
    border-radius: 25px;
   background-image: linear-gradient(165deg, 
		rgba(68, 62, 196, 0.75) 0%, 
		rgba(44, 119, 240, 0.75) 100%), 
	linear-gradient(
		#8380dc, 
		#8380dc);
	background-blend-mode: normal, 
		normal;
     li{
      flex: 1;
      height: 100%;
      text-align: center;
      color: #fff;
      font-size: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
     }
     li.work_li_sel{
      background-color: #8380dc;
	    border-radius: 26px;
     }
  }
  .technology_text{
    color: rgba(255, 255, 255, 0.48);
    font-size: 22px;
    line-height: 30px;
    text-align: center;
    margin-top: 27px;
  }
  .center_banner{
    width:100%;
    margin: 0 auto 80px;
    img{
      width: 100%;
    }
  }
  .parent_ul{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 19px 25px 26px 30px;
    div{
      width: 335px;
      height: auto;
      text-align: center;
      margin-bottom: 9px;
      img{
        width: 100%;
      }
    }
  }
  .home{
    min-height: 100vh;
    padding-bottom: 29px;
    background-color: rgb(17,98,228);
  }
  .banner{
    width: 100%;
  }
  .intr_box{
    width: 699px;
    height: 220px;
    position: relative;
    margin: 0px auto 0;
    background: url(~@/assets/img/intr.png)no-repeat;
    background-size: 100% 100%;
    &>div{
      position:relative;
      z-index: 3;
      font-size: 24px;
      max-height: 195px;
      color: #fff;
      line-height: 43px;
      padding:25px 31px 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      text-align: justify;
      &>div{
      }
      // &::before{
      //   content: '';
      //   width: 0;
      //   height: calc(43px*3);
      //   float: right;
      // }
      // span{
      //   float: right;
      //   clear: both;
      //   color: #FBDC59;
      // }
    }
    // &:before{
    //   content: '';
    //   width: 100%;
    //   height: calc(100% - 100px);
    //   background: url('@/assets/img/center.png') 100% 100%;
    //   background-position: center center;
    //   background-repeat: repeat;
    //   background-size: 100% 100px;
    //   position: absolute;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   left: 0;
    //   z-index: 1;
    // }
    // i{
    //   width: 100%;
    //   height: 100%;
    //   background: url('@/assets/img/top.png') no-repeat top left/100% 100px,
    //   url('@/assets/img/bottom.png') no-repeat bottom left/100% 100px;
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   z-index: 2;
    // }
  }
  .work_body{
    width: 699px;
    background-color: #fff;
    border-radius: 25px;
     margin: 0 auto;
  }
  .work_box{
    width: 699px;
    padding: 79px 0 37px;
    min-height: 400px;
    display: flex;
    transform: translateY(-5px);
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(165deg, 
		rgba(68, 62, 196, 0.75) 0%, 
		rgba(44, 119, 240, 0.75) 100%), 
	linear-gradient(
		#8380dc, 
		#8380dc);
	background-blend-mode: normal, 
		normal;
    border-radius: 25px;
    //  background: url('@/assets/img/top.png') no-repeat top left/100% 100px,
    //   url('@/assets/img/bottom.png') no-repeat bottom left/100% 100px,
    //   url('@/assets/img/center.png') no-repeat center center/100% calc(100% - 180px);
      position:relative;
      .work_title{
        position: absolute;
        top: 0;
        left: 0;
        width: 316px;
        height: 66px;
        left: 50%;
        transform: translateX(-50%);
        top: -33px;
        background: #5D5EF2;
        border-radius: 33px;
        border: 1px solid #B7AFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
        color: #fff;
        box-shadow: 5px 5px 0px rgba(73, 76, 225, 1);
      }
  }
// @ is an alias to /src
</style>
